import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";

export default class CardAdminProviderContact extends CardClass {
    /**
     * Render the content of the card.
     */
    renderContent() {
        const formatPhoneOrFaxNumber = (value) => {
            const cleaned = value.replace(/\D/g, '').slice(0, 10); // limit to 10 digits
            const length = cleaned.length;

            if (length === 0) return "";
            if (length < 4) return `(${cleaned}`;
            if (length < 7) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
            return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        };

        const handlePhoneOrFaxNumberChange = (event, prop) => {
            const { value } = event.target;
            const formatted = formatPhoneOrFaxNumber(value);
            this.props.onChange({ [prop]: formatted });
        };

        return (
            <MUIGrid container spacing={2}>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.provider && this.props.provider.address1 ? this.props.provider.address1 : ""}
                        size="small"
                        label="Address"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ address1: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ address1: e.target.value })}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.provider && this.props.provider.city ? this.props.provider.city : ""}
                        size="small"
                        label="City"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ city: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ city: e.target.value })}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.provider && this.props.provider.state ? this.props.provider.state : ""}
                        size="small"
                        label="State"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ state: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ state: e.target.value })}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.provider && this.props.provider.postalCode ? this.props.provider.postalCode : ""}
                        size="small"
                        label="Zip Code"
                        variant="standard"
                        fullWidth={true}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ postalCode: e.target.value.trim() })}
                        onChange={(e) => {
                            // Allow only digits
                            const value = e.target.value.replace(/[^0-9-]/g, '');
                            this.props.onChange({ postalCode: value });
                        }}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.provider && this.props.provider.phoneNumber ? formatPhoneOrFaxNumber(this.props.provider.phoneNumber) : ""}
                        size="small"
                        label="Phone"
                        variant="standard"
                        fullWidth={true}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({phoneNumber: e.target.value ? e.target.value.replace(/\D/g, '').slice(0, 10) : null})}
                        onChange={(e) => handlePhoneOrFaxNumberChange(e, 'phoneNumber')}
                        error={this.props.validationIssues.phoneNumber ? true : false}
                        helperText={this.props.validationIssues.phoneNumber ? this.props.validationIssues.phoneNumber : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.provider && this.props.provider.faxNumber ? formatPhoneOrFaxNumber(this.props.provider.faxNumber) : ""}
                        size="small"
                        label="Fax"
                        variant="standard"
                        fullWidth={true}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({faxNumber: e.target.value ? e.target.value.replace(/\D/g, '').slice(0, 10) : null})}
                        onChange={(e) => handlePhoneOrFaxNumberChange(e, 'faxNumber')}
                        error={this.props.validationIssues.faxNumber ? true : false}
                        helperText={this.props.validationIssues.faxNumber ? this.props.validationIssues.faxNumber : ""}
                    />
                </MUIGrid>
            </MUIGrid>
        );
    }

    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "Contact";
    }
}